import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "./root";

type RouteState = {
  id: number;
  location: string;
  route: string;
  page: any;
};

const initialState = {
  location: "",
  id: -1,
  route: "",
  page: {},
} as RouteState;

const routeSlice = createSlice({
  name: "route",
  initialState,
  reducers: {
    setRouteLocation(state, action: PayloadAction<string>) {
      state.location = action.payload;
    },
    setRoutePage(state, action: PayloadAction<string>) {
      state.page = action.payload;
    },
  },
});

export const getRouteLocation = (state: RootState) => state.routes.location; // Selector

export const getRoutePage = (state: RootState) => state.routes.page; // Selector

export const { setRouteLocation, setRoutePage } = routeSlice.actions; // Auto-generated action

export default routeSlice.reducer;
